import { render } from "./LinkTreeLink.vue?vue&type=template&id=3f06d305&scoped=true"
import script from "./LinkTreeLink.vue?vue&type=script&lang=js"
export * from "./LinkTreeLink.vue?vue&type=script&lang=js"

import "./LinkTreeLink.vue?vue&type=style&index=0&id=3f06d305&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f06d305"]])

export default __exports__